import React, { AnchorHTMLAttributes, useEffect } from 'react';
import clsx from 'clsx';

import { useStyles } from './Button';
import { Link } from 'react-router-dom';

export interface LinkButtonProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  color?: 'primary' | 'secondary' | 'danger' | 'success' | 'info';
  size?: 'small' | 'medium' | 'large' | 'wide';
  rounded?: boolean;
  target?: string;
  isLink?: boolean;
  to?: string
}

const LinkButton: React.FC<LinkButtonProps> = ({
  className,
  color = 'primary',
  size = 'medium',
  target = '_blank',
  rounded,
  children,
  isLink,
  to,
  ...others
}) => {
  const classes = useStyles();

  return (
    <>
      {
        !isLink ? (
          <a
            className={clsx(
              'btn',
              classes.base,
              {
                [classes.primary]: color === 'primary',
                [classes.secondary]: color === 'secondary',
                [classes.small]: size === 'small',
                [classes.medium]: size === 'medium',
                [classes.large]: size === 'large',
                [classes.wide]: size === 'wide',
                [classes.rounded]: rounded,
                'btn-danger': color === 'danger',
                'btn-info': color === 'info',
                'btn-success': color === 'success',
              },
              className,
            )}
            {...others}
          >
            {children}
          </a>
        ) : (
          <Link
            target={target}
            to={to || ""}
            className={clsx(
              'btn',
              classes.base,
              {
                [classes.primary]: color === 'primary',
                [classes.secondary]: color === 'secondary',
                [classes.small]: size === 'small',
                [classes.medium]: size === 'medium',
                [classes.large]: size === 'large',
                [classes.wide]: size === 'wide',
                [classes.rounded]: rounded,
                'btn-danger': color === 'danger',
                'btn-info': color === 'info',
                'btn-success': color === 'success',
              },
              className,
            )}
            {...others}
          >
            {children}
          </Link>
        )
      }
    </>
  )
  // <div></div>




  //     {
  //     !isLink ? (
  //     <a
  //       className={clsx(
  //         'btn',
  //         classes.base,
  //         {
  //           [classes.primary]: color === 'primary',
  //           [classes.secondary]: color === 'secondary',
  //           [classes.small]: size === 'small',
  //           [classes.medium]: size === 'medium',
  //           [classes.large]: size === 'large',
  //           [classes.wide]: size === 'wide',
  //           [classes.rounded]: rounded,
  //           'btn-danger': color === 'danger',
  //           'btn-info': color === 'info',
  //           'btn-success': color === 'success',
  //         },
  //         className,
  //       )}
  //       {...others}
  //     >
  //       {children}
  //     </a>
  //   ) : (
  //     )
  // }

};

export default LinkButton;
